import axios from "axios";
import { toast } from "react-toastify";
import authHeader from "./auth-header";

export const fetchAllVouchers = (filters = {}) => {
  let queryArr = [];
  for (let key in filters) {
    if (filters[key] !== "") {
      queryArr.push(`${key}=${encodeURIComponent(filters[key])}`);
    }
  }
  let url = "?" + queryArr.join("&");
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/voucher${url}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const fetchOneVoucher = (id) => {
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/voucher/${id}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const createVoucher = (data) => {
  return axios
    .post(`${process.env.REACT_APP_BASE_URL}/voucher/`, data, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const updateVoucher = (id, data) => {
  return axios
    .put(`${process.env.REACT_APP_BASE_URL}/voucher/${id}`, data, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const deleteVoucher = (id) => {
  return axios
    .delete(`${process.env.REACT_APP_BASE_URL}/voucher/${id}`, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const viewVoucherReport = (id) => {
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/voucher/view-report/${id}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg || "Error generating voucher report");
      throw err;
    });
};

export const getNextVoucherNumber = (trtyp) => {
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/voucher/next-number`, {
      params: { trtyp },
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg || "Error fetching next voucher number");
      throw err;
    });
};

export const getOutstandingBills = (vendorId, customerId) => {
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/voucher/outstanding-bills`, {
      params: { vendorId, customerId },
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg || "Error fetching outstanding bills");
      throw err;
    });
};
